export default "__VITE_ASSET__cd958b26__"